import {useParams} from 'react-router'
import {BillingInfo} from '@eitje/api'
import {PageLayout, BillingInfosBasicTable} from '~/components'
import {BillingInfoHeader} from './billing_info_header'
import {getFirmStatus} from '~/helpers'

export const ShowBillingInfo = () => {
	const tableData = useTableData()

	return (
		<PageLayout
			bodyWidth={800}
			name="show_billing_info"
			direction="vertical"
			padding="- - 24 -"
			floating
			headers={<BillingInfoHeader company_name={tableData.company_name} />}
		>
			<BillingInfosBasicTable data={tableData} />
		</PageLayout>
	)
}

const useTableData = () => {
	const {id} = useParams()
	const billingInfo = BillingInfo.useFind(id, {joins: ['environments', 'organisations']})

	const {organisation, environments} = billingInfo

	return {
		...billingInfo,
		organisation: organisation?.name,
		environments: environments._map('naam'),
		status: getFirmStatus(environments),
		first_billing_date: organisation?.first_billing_date,
	}
}
